import { render, staticRenderFns } from "./counter.vue?vue&type=template&id=3e346b8a&scoped=true"
import script from "./counter.vue?vue&type=script&lang=js"
export * from "./counter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e346b8a",
  null
  
)

export default component.exports